import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  signal,
  WritableSignal,
} from '@angular/core';

@Component({
  standalone: false,
  selector: 'gstar-import-result-modal',
  templateUrl: './import-result-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImportResultModalComponent implements OnInit {
  @Input({ required: true }) title!: string;
  @Input({ required: true }) content!: string;
  @Input({ required: true }) modalTitle!: string;
  @Input({ required: true }) success!: boolean;
  @Input() modalId!: string;

  messageList: WritableSignal<string[]> = signal<string[]>([]);

  constructor() {}

  ngOnInit(): void {
    if (this.content)
      this.messageList.set(
        this.content.split('\n').filter((error: string) => error.length > 0)
      );
  }
}
